import { type ReactElement } from 'react';
import {
  RiBarcodeBoxLine,
  RiCalendarCheckFill,
  RiCalendarScheduleFill,
  RiCapsuleFill,
  RiDropFill,
  RiFlagFill,
  RiFlagLine,
  RiPriceTag3Fill,
  RiSyringeFill,
  RiSyringeLine,
  RiChat3Fill,
  RiTestTubeFill,
  RiTimerFill,
  RiTimerLine,
} from 'react-icons/ri';
import { TbMathFunction, TbRuler, TbScale, TbWeight } from 'react-icons/tb';
import type { DataTableColumnType } from '@/components/UI/DataTableV2/DataTable.model';

interface DataTableColumnTypeIconProps {
  type: DataTableColumnType;
}

export function DataTableColumnTypeIcon({ type }: DataTableColumnTypeIconProps): ReactElement {
  switch (type) {
    case 'number':
      return <span>#</span>;
    case 'text':
      return <span>☰</span>;
    case 'timestamp':
    case 'timestampBaseline':
    case 'timestampBaselineRelative':
      return <RiTimerLine size={12} />;
    case 'formula':
      return <TbMathFunction size={12} />;
    case 'measurement':
      return <TbRuler size={12} />;
    case 'observation':
      return <TbScale size={12} />;
    case 'sample':
    case 'sampleDetail':
      return <RiTestTubeFill size={12} />;
    case 'sampleId':
      return <RiBarcodeBoxLine size={12} />;
    case 'sampleStatus':
      return <RiFlagFill size={12} />;
    case 'sampleCollectedAt':
      return <RiCalendarCheckFill size={12} />;
    case 'samplePlannedAt':
      return <RiCalendarScheduleFill size={12} />;
    case 'sampleDoseTime':
      return <RiSyringeFill size={12} />;
    case 'sampleComments':
      return <RiChat3Fill size={12} />;
    case 'dosingSession':
      return <RiSyringeLine size={12} />;
    case 'doseTreatment':
      return <RiCapsuleFill size={12} />;
    case 'doseWeight':
      return <TbWeight size={12} />;
    case 'doseVolume':
      return <RiDropFill size={12} />;
    case 'dosedAt':
      return <RiTimerFill size={12} />;
    case 'doseStatus':
      return <RiFlagLine size={12} />;
    case 'metadata':
      return <RiPriceTag3Fill size={12} />;
  }
}
